import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AvatarGlobal } from '../UI/AvatarGlobal';

const AvatarContainer = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  height: '100%',
  maxHeight: '120px',
  minHeight: '90px',
  width: '100%',
  maxWidth: '122px',
  minWidth: '92.83px',
});

const AvatarWrap = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  width: '100%',
  minHeight: '90px',
  minWidth: '92.83px',
  margin: '0px',
});

function AvatarDashboard() {
  return (
    <AvatarContainer>
      <AvatarWrap>
        <AvatarGlobal />
      </AvatarWrap>
    </AvatarContainer>
  );
}

export default AvatarDashboard;
